import React, { lazy, useContext, useEffect, useState } from "react";
import styles from "./Step.module.css";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import info from "../../../assets/componentAssets/info.svg";
import { CheckBox } from "@mui/icons-material";
import CustomCheckBox from "../../../Components/CustomCheckBox/CustomCheckBox";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import property from "../../../assets/componentAssets/property.svg";
import NavButton from "./NavButton";
import { PatchApi, getApi } from "../../../Utility/network";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { monthYear } from "../utility/utils";
import FormHelperText from "@mui/material/FormHelperText";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import { selectedLanguage } from "../../../Utility/helper";
import { consumCertGerText } from "../../../Utility/gerLangObject";
import { consumCertEngText } from "../../../Utility/engLangObject";

function Step5() {
  const { state, setState, HandleErrorPop } = useContext(AppContext);
  const { stepLanguage, language } = state;
  const [formD, setFormD] = useState(dd);
  const [response, setResponse] = useState(false);
  const [disableNext, setDisableNext] = useState(true);

  const style = { width: "100%" };
  const [data, setData] = useState({ heating: [] });
  const [submitData, setSubmitData] = useState({
    living_space: "",
    building_part: "",
    ventilation_id: [],
    was_the_1977_thermal_insulation_regulation_met: false,

    does_property_have_basement: false,
    what_lies_below_the_ground_floor: null,

    are_renewable_energy_used: false,
    type_of_renewable_energy_id: [],
    energy_used_for_id: [],

    is_there_cooling_system: false,
    type_of_cooling_system_used_id: [],

    optional_information_abt_equipment: false,

    sun_protection: null,
    does_the_property_have_thermal_insulation: false,
    is_there_roof_or_attic_insulation: false,
  });
  const [ventilation, setVentaltion] = useState([]);
  const [coolings, setCoolings] = useState([]);
  const [renewable, setRenewable] = useState([]);
  const [renewableFor, setRenewableFor] = useState([]);
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  // New state variables for error messages
  const [errors1, setErrors1] = useState([]);
  const [errors, setErrors] = useState({
    living_space: "",
    building_part: "",
    sun_protection: "",
  });
  const options = [];
  const [buildType, setBuildType] = useState([]);
  useEffect(() => {
    getData();
    getList();
    window.scroll(0, 0);
  }, []);

  const getList = async () => {
    try {
      const ven = await getApi(`/energy_consumption/ventilation`);
      const cool = await getApi(`/energy_consumption/colling_system_types`);
      const renew = await getApi(`/energy_consumption/renewable_energy_types`);
      const renewFor = await getApi(`/energy_consumption/renewable_energy_for`);
      setVentaltion(ven.data.data);
      setCoolings(cool.data.data);
      setRenewable(renew.data.data);
      setRenewableFor(renewFor.data.data);
      setDisableNext(false);
    } catch (error) {}
  };

  useEffect(() => {
    if (
      state.otherData &&
      state.otherData?.yearArray &&
      state.otherData?.yearArray.length > 0
    ) {
      const err = state?.otherData?.yearArray.map((item, index) => {
        return { installation_year: "" };
      });
      setErrors1(err);
      setData((prev) => ({ ...prev, heating: state.otherData.yearArray }));
      setSubmitData((prev) => ({ ...prev, ...state.otherData.info }));
    }
  }, [state.otherData]);

  const getData = async () => {
    try {
      const responseData = await getApi(`/energy_consumption/building_type`);
      setBuildType(responseData.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (
      !submitData.living_space ||
      isNaN(submitData.living_space) ||
      submitData.living_space <= 0
    ) {
      newErrors.living_space = `${stepLanguage.pos_number}`;
    }
    if (!submitData.building_part) {
      newErrors.building_part = `${stepLanguage.building_part}`;
    }
    // if (!submitData.sun_protection) {
    //   newErrors.sun_protection = `${stepLanguage.sun_prot}`;
    // }
    // data.heating
    // state.otherData.construction_year
    const { heating } = data;
    const currentYear = new Date().getFullYear();
    const err = [...errors1];
    for (let i = 0; i < heating.length; i++) {
      if (
        heating[i].installation_year < state.otherData.construction_year ||
        heating[i].installation_year > currentYear
      ) {
        newErrors[`installation_year${i}`] = "error in date";
        err[
          i
        ].construction_year = `${stepLanguage.year_val} ${state.otherData.construction_year} ${stepLanguage.and} ${currentYear} ${stepLanguage.year}`;
      } else {
        err[i].construction_year = "";
      }
      setErrors1(err);
    }
    return newErrors;
  };
  const validateArrayOfObjects = (arrayOfObjects) => {
    const errors = arrayOfObjects.map((obj) => {
      const errorObj = {}; // Create an error object for each item

      // Check if the key exists and its value is an empty string, null, or undefined
      if (
        obj.construction_year === "" ||
        obj.construction_year === null ||
        obj.construction_year === undefined
      ) {
        errorObj["construction_year"] = `This field cannot be empty.`; // Add error message
      }

      return errorObj;
    });

    return errors;
  };

  const handleSubmit = async (num, type) => {
    // Validate fields before submitting
    if (type === "next") {
      const validationErrors = validateFields();
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return; // Prevent submission if there are validation errors
      }
    }
    try {
      if (type === "next") {
        try {
          const { sun_protection } = submitData;
          const postData = await PatchApi(
            `/energy_consumption/form/${state.form_id}/`,
            {
              ...submitData,
              sun_protection: sun_protection ? sun_protection : null,
              heating_info: data.heating,
              language: language === "de" ? 2 : 1,
            }
          );
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              filledPage: prev.filledPage >= 6 ? prev.filledPage : 6,
              page: 6,
              otherData: {
                ...prev.otherData,
                info: submitData,
                yearArray: data.heating,
              },
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          HandleErrorPop(true);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, page: prev.page - 1 }));
      } else if (type === "save") {
        await getApi(`/energy_consumption/form/${state.form_id}/generate_link`);
        // navigate("/login");
        setResponse(true);
      }
    } catch (error) {
      HandleErrorPop(true);
    }
  };

  const handleField = (e) => {
    const { value, name } = e.target;
    setFormD((prev) => ({ ...prev, [name]: value }));
  };

  const handleChange1 = (e) => {
    const { value, name } = e.target;
    setSubmitData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormD((prev) => ({ ...prev, [name]: value }));

    const newErrors = validateFields();

    // Remove the error for the specific field if it is valid
    if (value) {
      setErrors((prevErrors) => {
        // Copy the previous errors and remove the error for the specific field
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    } else {
      setErrors(newErrors);
    }
  };

  const handleRadioChange = (event) => {};

  const handleChange = (event) => {
    const { name, value } = event.target;
    let parsedValue = value;
    // Check if the value is a boolean string
    if (value === "true") {
      parsedValue = true;
    } else if (value === "false") {
      parsedValue = false;
    }
    // Check if the value is a number string
    else if (!isNaN(value) && value.trim() !== "") {
      parsedValue = parseFloat(value);
    }
    setSubmitData((prev) => ({
      ...prev,
      [name]: parsedValue, // Assign the parsed value (boolean, number, or string)
    }));

    const newErrors = validateFields();

    // Remove the error for the specific field if it is valid
    if (value) {
      setErrors((prevErrors) => {
        // Copy the previous errors and remove the error for the specific field
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    } else {
      setErrors(newErrors);
    }
  };

  const handleCheckboxChange = (name, checkedIds) => {
    if (name === "ventilation_id") {
      setSubmitData((prev) => ({ ...prev, ventilation_id: checkedIds }));
    }
    if (name === "type_of_cooling_system_used_id") {
      setSubmitData((prev) => ({
        ...prev,
        type_of_cooling_system_used_id: checkedIds,
      }));
    }
    if (name === "type_of_renewable_energy_id") {
      setSubmitData((prev) => ({
        ...prev,
        type_of_renewable_energy_id: checkedIds,
      }));
    }
    if (name === "energy_used_for_id") {
      setSubmitData((prev) => ({
        ...prev,
        energy_used_for_id: checkedIds,
      }));
    }
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const popData = {
    installed: [
      {
        heading: stepLanguage.install_h,
        para1: stepLanguage.install_d,
      },
    ],
    ventilation: [
      {
        heading: stepLanguage.ventilation_h,
        para1: stepLanguage.ventilation_d,
      },
    ],
    livingSpace: [
      {
        heading: stepLanguage.livingSpace_h,
        para1: stepLanguage.livingSpace_d,
      },
    ],
    building: [
      {
        heading: stepLanguage.building_h,
        para1: stepLanguage.building_d1,

        para2: stepLanguage.building_d2,
        para3: stepLanguage.building_d3,
      },
    ],
    thermal: [
      {
        heading: stepLanguage.thermal_h,
        para1: stepLanguage.thermal_heading,

        para2: stepLanguage.thermal_point1,
        para3: stepLanguage.thermal_point2,
        para4: stepLanguage.thermal_point3,
        para5: stepLanguage.thermal_point4,
        para6: stepLanguage.thermal_point5,
      },
    ],
    below_ground: [
      {
        heading: stepLanguage.below_ground,
        para1: stepLanguage.below_ground_info1,

        para2: stepLanguage.below_ground_info2,
      },
    ],
    cooling: [
      {
        heading: stepLanguage.cooling_s,
        para1: stepLanguage.cooling_s_info,
      },
    ],
    ellusion: [
      {
        heading: stepLanguage.ellusion,
        para1: stepLanguage.ellusion_info,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={property}
          heading={state?.headerLanguage?.property_info}
          secPara={stepLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          <div className={styles.fieldCom}>
            {data.heating.map((item, index) => {
              let value = null;
              if (
                item.consumption_info !== null &&
                item.consumption_info.length > 0
              ) {
                value = monthYear(item.consumption_info[0].date);
              }
              let suffix = language === "de" ? "." : suffixArr[index];
              return (
                <div className={styles.fields}>
                  <p className={styles.fieldName}>
                    {stepLanguage.heating_system_installed_on1} {index + 1}
                    {suffix} {stepLanguage.heating_system_installed_on2} {value}
                    <img
                      src={info}
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePopUp(popData?.installed)}
                    />
                  </p>
                  {item.consumption}
                  <TextField
                    size="small"
                    value={item.installation_year}
                    style={style}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      let newData = [...data.heating];
                      const value = e.target.value;
                      const currentYear = new Date().getFullYear();
                      newData[index].installation_year = e.target.value;
                      setData({ heating: newData });
                      if (
                        value < Number(state.otherData.construction_year) ||
                        value > currentYear
                      ) {
                        const err = [...errors1];
                        err[
                          index
                        ].construction_year = `${stepLanguage.year_val} ${state?.otherData?.construction_year} ${stepLanguage.and} ${currentYear}`;
                        setErrors1(err);
                      } else {
                        const err = [...errors1];
                        err[index].construction_year = ``;
                        setErrors1(err);
                      }
                    }}
                    error={errors1[index].construction_year}
                    helperText={errors1[index].construction_year}
                    type="number"
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position="end">Kwh</InputAdornment>
                    //   ),
                    // }}
                  />
                </div>
              );
            })}
          </div>
          <div className={styles.fieldCom1}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.type_of_ventilation}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.ventilation)}
                />
              </p>
              {ventilation.length > 0 && (
                <CustomCheckBox
                  data={ventilation}
                  name="ventilation_id"
                  onCheckChange={handleCheckboxChange}
                  selectedValues={submitData.ventilation_id}
                />
              )}
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.living_space}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.livingSpace)}
                />
              </p>
              <TextField
                size="small"
                style={style}
                name="living_space"
                type="text"
                onChange={handleChange}
                error={!!errors.living_space}
                helperText={errors.living_space}
                onWheel={(e) => e.target.blur()}
                value={submitData.living_space}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {stepLanguage.sqm}
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div className={styles.fieldCom1}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.insulation_regulation_met}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.thermal)}
                />
              </p>
              <FormControl>
                <RadioGroup
                  name="was_the_1977_thermal_insulation_regulation_met" // Name of the radio group
                  value={
                    submitData.was_the_1977_thermal_insulation_regulation_met
                  } // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={stepLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={stepLanguage.no}
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.building_part}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.building)}
                />
              </p>
              <Select
                style={style}
                size="small"
                name="building_part"
                onChange={handleChange1}
                error={!!errors.building_part}
                helperText={errors.building_part}
                value={submitData.building_part}
              >
                {buildPart.map((option) => (
                  <MenuItem key={option.title} value={option.id}>
                    {selectedLanguage(option, language)}
                  </MenuItem>
                ))}
              </Select>
              {errors.building_part && (
                <p
                  style={{
                    fontSize: "12px",
                    margin: "4px 14px 0",
                    color: "#d32f2f",
                  }}
                >
                  {errors.building_part}
                </p>
              )}
            </div>
          </div>
          <div className={styles.fieldDetailsCon}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.property_have_basement}
              </p>
              <RadioGroup
                name="does_property_have_basement" // Name of the radio group
                value={submitData.does_property_have_basement} // Bind the state value
                onChange={handleChange} // Handle value changes
              >
                <div className={styles.Radio}>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={stepLanguage.yes}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label={stepLanguage.no}
                  />
                </div>
              </RadioGroup>
            </div>
            {submitData.does_property_have_basement && (
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.lies_below_ground_floor}
                  <img
                    src={info}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePopUp(popData?.below_ground)}
                  />
                </p>
                <RadioGroup
                  name="what_lies_below_the_ground_floor" // Name of the radio group
                  value={submitData.what_lies_below_the_ground_floor} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio1}>
                    {liesBelow.map((item, index) => {
                      return (
                        <FormControlLabel
                          value={item.id}
                          control={<Radio />}
                          label={selectedLanguage(item, language)}
                        />
                      );
                    })}
                  </div>
                </RadioGroup>
              </div>
            )}
          </div>
          <div className={styles.fieldDetailsCon}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.renewables_energy_used}
              </p>
              <FormControl>
                <RadioGroup
                  name="are_renewable_energy_used" // Name of the radio group
                  value={submitData.are_renewable_energy_used} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={stepLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={stepLanguage.no}
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.fieldCom}>
              {submitData.are_renewable_energy_used && (
                <div className={styles.fields}>
                  <p className={styles.fieldName}>{stepLanguage.do_you_use}</p>
                  {renewable.length > 0 && (
                    <CustomCheckBox
                      data={renewable}
                      name="type_of_renewable_energy_id"
                      onCheckChange={handleCheckboxChange}
                      selectedValues={submitData.type_of_renewable_energy_id}
                    />
                  )}
                </div>
              )}
              {submitData.are_renewable_energy_used && (
                <div className={styles.fields}>
                  <p className={styles.fieldName}>
                    {stepLanguage.renewables_energy_used_for}
                  </p>
                  {renewableFor.length > 0 && (
                    <CustomCheckBox
                      data={renewableFor}
                      name="energy_used_for_id"
                      onCheckChange={handleCheckboxChange}
                      selectedValues={submitData.energy_used_for_id}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <div className={styles.fieldDetailsCon}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.cooling_system}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.cooling)}
                />
              </p>
              <FormControl>
                <RadioGroup
                  name="is_there_cooling_system" // Name of the radio group
                  value={submitData.is_there_cooling_system} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={stepLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={stepLanguage.no}
                    />
                  </div>
                </RadioGroup>
              </FormControl>
              {submitData.is_there_cooling_system && (
                <div>
                  {coolings.length > 0 && (
                    <CustomCheckBox
                      data={coolings}
                      name="type_of_cooling_system_used_id"
                      onCheckChange={handleCheckboxChange}
                      selectedValues={submitData.type_of_cooling_system_used_id}
                    />
                  )}
                </div>
              )}
            </div>
          </div>

          <div className={styles.fieldDetailsCon}>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.optional_information_about_equipment}
              </p>
              <RadioGroup
                name="optional_information_abt_equipment" // Name of the radio group
                value={submitData.optional_information_abt_equipment} // Bind the state value
                onChange={handleChange} // Handle value changes
              >
                <div className={styles.Radio}>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={stepLanguage.yes}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label={stepLanguage.no}
                  />
                </div>
              </RadioGroup>
            </div>
            <FormHelperText style={{ color: "red" }}>
              {errors.sun_protection}
            </FormHelperText>
            {submitData.optional_information_abt_equipment && (
              <div className={styles.fields}>
                <p className={styles.fieldName}>
                  {stepLanguage.sun_protection}
                </p>

                <FormControl>
                  <RadioGroup
                    name="sun_protection" // Name of the radio group
                    value={submitData.sun_protection} // Bind the state value
                    onChange={handleChange} // Handle value changes
                    error={!!errors.sun_protection}
                  >
                    <div className={styles.Radio1}>
                      {sunProtection.map((item, index) => {
                        return (
                          <FormControlLabel
                            value={item.id}
                            control={<Radio />}
                            label={selectedLanguage(item, language)}
                          />
                        );
                      })}
                    </div>
                  </RadioGroup>

                  {/* {errors.sun_protection && (
                  <p style={{fontSize:"12px", margin:"4px 14px 0", color:"#d32f2f"}}>{errors.sun_protection}</p>
                )} */}
                </FormControl>
              </div>
            )}
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.insulation_glazing}
              </p>
              <RadioGroup
                name="does_the_property_have_thermal_insulation" // Name of the radio group
                value={submitData.does_the_property_have_thermal_insulation} // Bind the state value
                onChange={handleChange} // Handle value changes
              >
                <div className={styles.Radio}>
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={stepLanguage.yes}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label={stepLanguage.no}
                  />
                </div>
              </RadioGroup>
            </div>
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                {stepLanguage.attic_insulation}
                <img
                  src={info}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePopUp(popData?.ellusion)}
                />
              </p>
              <FormControl>
                <RadioGroup
                  name="is_there_roof_or_attic_insulation" // Name of the radio group
                  value={submitData.is_there_roof_or_attic_insulation} // Bind the state value
                  onChange={handleChange} // Handle value changes
                >
                  <div className={styles.Radio}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={stepLanguage.yes}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={stepLanguage.no}
                    />
                  </div>
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
        disabled={disableNext}
      />

      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step5;
const Ventilations = [
  { id: 1, label: "Windows Ventilation" },
  { id: 2, label: "Shaft Ventilation" },
  { id: 3, label: "Ventilation system without heat recovery" },
  { id: 4, label: "Ventilation system without heat recovery" },
  { id: 5, label: "Exhaust air system" },
];
const Energy = [
  { id: 1, label: "Solar thermal energy" },
  { id: 2, label: "Photovoltaics" },
  { id: 3, label: "Heat pump" },
  { id: 4, label: "Biomass" },
];
const renewables = [
  { id: 1, label: "Heating" },
  { id: 2, label: "Hotwater" },
  { id: 3, label: "Electricity" },
];
const cooling = [
  { id: 1, label: "Cooling from electricity" },
  { id: 2, label: "Delivered cold" },
  { id: 3, label: "Passive cooling" },
  { id: 4, label: "Cooling from heat" },
];

const dd = {
  was_the_1977_thermal_insulation_regulation_met: false,
  building_part: null,
  ventilation_id: [],
  type_of_renewable_energy_id: [],
  energy_used_for_id: [],
  is_there_cooling_system: "",
  type_of_cooling_system_used_id: [],
  living_space: null,

  does_property_have_basement: false,
  what_lies_below_the_ground_floor: null,

  are_renewable_energy_used: false,
  type_of_renewable_energy: null,
  energy_used_for: null,

  is_there_cooling_system: false,
  type_of_cooling_system_used: null,

  optional_information_abt_equipment: false,
  sun_protection: null,
  does_the_property_have_thermal_insulation: null,
  is_there_roof_or_attic_insulation: null,
};

const buildPart = [
  {
    title: "Total building",
    german_title: "Gesamtgebäude",
    id: 1,
  },
  {
    title: "Residential part of mixed building",
    german_title: "Wohnteil eines gemischten Gebäudes",
    id: 2,
  },
];

const liesBelow = [
  {
    title: consumCertEngText.unheated_basement,
    german_title: consumCertGerText.unheated_basement,
    id: 1,
  },
  {
    title: consumCertEngText.heated_cellar,
    german_title: consumCertGerText.heated_cellar,
    id: 2,
  },
  {
    title: consumCertEngText.no_floor_slab,
    german_title: consumCertGerText.no_floor_slab,
    id: 3,
  },
];

const sunProtection = [
  {
    title: consumCertEngText.glare_protection,
    german_title: consumCertGerText.glare_protection,
    id: 1,
  },
  {
    title: consumCertEngText.flare_protection,
    german_title: consumCertGerText.flare_protection,
    id: 2,
  },
  {
    title: consumCertEngText.only_glare_protection,
    german_title: consumCertGerText.only_glare_protection,
    id: 3,
  },
  {
    title: consumCertEngText.light_directing,
    german_title: consumCertGerText.light_directing,
    id: 4,
  },
];

const suffixArr = ["st", "nd", "rd", "th"];
